import React, { useContext, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import { HeaderHLPure, GridPure, SearchBarHLPure, ButtonAddHLPure, ModalUtil } from "../../pures";
import { useHistory } from 'react-router-dom'
import Swal from 'sweetalert2'
import { Context } from "../../../Context";
import publicityImg from '../../../assets/modal-icons/publicity.png'
import multiplePublicityImg from '../../../assets/modal-icons/multiple-publicity.png'

const PublicityView = (props) => {
  const { allowedActions } = useContext(Context);
  const { t: transl } = useTranslation('publicity', { keyPrefix: 'publicityScreen' })
  const { t } = useTranslation();
  const [selectedValueFilter, setSelectedValue] = useState("Pendiente")
  const history = useHistory()
  const modalUtil = new ModalUtil()
  const hideActions = useMediaQuery('(max-width: 820px)');

  const [searchPublicity, setSearchPublicity] = useState('');

  const handleChangeSearch = (e) => setSearchPublicity(e.target.value);

  const { deletePublicity } = props

  const strToboolean = (value) => {
    if (value && typeof value === "string") {
      if (value.toLowerCase() === "true") return true;
      if (value.toLowerCase() === "false") return false;
    }
    return value;
  };

  const filterChange = (e) => {
    const selectedOption = strToboolean(e.target.value);
    setSelectedValue(selectedOption);
  };

  const data = props.publicitys

  const selectOption = () => {
    modalUtil.customModal({
      modalTitle: transl('modalTitle'),
      id1: 'individual-publicity',
      title1: transl('modalOptionTitle1'),
      text1: transl('modalText1'),
      image1: publicityImg,
      imageStyle1: '50px;',
      id2: 'multiple-publicity',
      title2: transl('modalOptionTitle2'),
      text2: transl('modalText2'),
      image2: multiplePublicityImg,
      imageStyle2: '100px;'
    }, () => {
      document.getElementById('individual-publicity').addEventListener('click', () => {
        history.push('add-publicity')
        Swal.close()
      })

      document.getElementById('multiple-publicity').addEventListener('click', () => {
        history.push('create-publicities')
        Swal.close()
      })
    })
  }

  const publicityGrid = useMemo(() => {
    if (!searchPublicity) return data;

    const lowercasedSearchPublicity = searchPublicity.toLowerCase();
    const filteredPublicity = data.filter(el => el.name.toLowerCase().includes(lowercasedSearchPublicity))
    return filteredPublicity
  }, [data, searchPublicity])

  return (
    <Container className="view-container publicityView">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <HeaderHLPure title={transl("title")} />
        </Grid>
        <Grid item xs={12} className="add-and-search-container">
          {
            allowedActions && allowedActions.create &&
            <ButtonAddHLPure
              iconAdd={true}
              nameBtn={transl('buttonAdd')}
              onClick={() => { selectOption() }}
            />
          }
          <SearchBarHLPure
            placeholder={t("search")}
            labelFilter="Filtrar por"
            options={props.optionsFilter}
            nameOption="status"
            statusValueFilter={selectedValueFilter === true ? "Activo" : selectedValueFilter === false ? "Inactivo" : "Todos"}
            optionsValue={"Todos"}
            onFilterChange={(e) => filterChange(e)}
            onSearchChange={((e) => handleChangeSearch(e))}
          />
        </Grid>
        <Grid item xs={12}>
          <GridPure
            {...props}
            dataGrid={publicityGrid}
            skip={0}
            take={11}
            rowsItems={[{
              field: 'name',
              title: transl("columnName"),
              width: 200,
              sorteable: true
            },
            {
              field: 'startDate',
              title: transl("columnStartDate"),
              width: 130,
              sorteable: true
            },
            {
              field: 'endDate',
              title: transl("columnEndDate"),
              width: 130,
              sorteable: true
            },
            {
              field: 'Acciones',
              title: hideActions ? '' : t("columnActions"),
              width: hideActions ? 75 : 150,
              actions: true,
              headerClassName: 'actionHeader'
            }]}
            actions={[
              {
                type: 'view-details',
                value: t('gridPure.columnActions.details'),
                onClick: (dataItem) => { history.push(`publicity-details?&publicityId=${dataItem.id}`) }
              },
              allowedActions && allowedActions.delete &&
              {
                type: 'icon',
                value: 'k-icon k-i-delete k-i-trash',
                onClick: (dataItem) => { deletePublicity(dataItem.id) }
              },
            ]}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export { PublicityView as default };